module.exports = __webpack_public_path__ + "img/scriptWidget.8aab9d65.png";